import { Row } from 'components/Layout/Grid';
import styled from 'styled-components';

interface PeriodProps {
  isMobile?: boolean;
}

export const TrackItemStyled = styled(Row) <PeriodProps>`
  .text-uppercase-first-letter {
    text-transform: lowercase;

    &::first-letter {
      text-transform: uppercase;
    }
  }

  ${(props) =>
    props.isMobile &&
    `
    gap: 25px;
    justify-content: center;
  `}
`;
